import React from 'react';

interface SectionProps {
  title: string;
  description: string;
  bullets?: string[];
  image: string;
  reversed?: boolean;
  backgroundColor?: string;
  extraContent?: React.ReactNode;
}

export default function Section({ 
  title, 
  description, 
  bullets = [], 
  image, 
  reversed = false, 
  backgroundColor = '',
  extraContent
}: SectionProps) {
  return (
    <section className={`py-20 ${backgroundColor}`}>
      <div className="container-custom">
        <div className={`grid grid-cols-1 ${reversed ? 'md:grid-cols-[45%_55%]' : 'md:grid-cols-[55%_45%]'} items-center gap-12 ${reversed ? 'md:gap-20' : ''}`}>
          <div className={`${reversed ? 'md:order-2' : ''}`}>
            <h2 className="text-4xl md:text-5xl font-title font-bold leading-tight mb-6">
              {title}
            </h2>
            <p className="text-lg text-neutral-800 mb-8">
              {description}
            </p>
            {bullets && bullets.length > 0 && (
              <ul className="space-y-4">
                {bullets.map((bullet, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="text-primary mt-1">✓</span>
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            )}
            {extraContent}
          </div>
          
          <div className={`${reversed ? 'md:order-1' : ''}`}>
            <img
              src={image}
              alt={title}
              className="w-full max-w-[600px] mx-auto h-auto rounded-lg shadow-lg bg-transparent"
            />
          </div>
        </div>
      </div>
    </section>
  );
}